import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button } from '@mui/material';

type SimilarItemWorkbenchEntryProps = {
  visible: boolean;
  suggestionCount: number;
};

const SimilarItemWorkbenchEntry: React.FC<SimilarItemWorkbenchEntryProps> = ({
  visible,
  suggestionCount,
}) => {
  if (!visible || suggestionCount <= 0) {
    return null;
  }

  const label = suggestionCount === 1
    ? '1 similar-item suggestion is ready for review.'
    : `${suggestionCount} similar-item suggestions are ready for review.`;

  return (
    <Alert
      severity="info"
      className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between"
      data-testid="WORKBENCH_SIMILAR_ITEM_ENTRY"
    >
      <span>{label} Approve before any bulk domain change.</span>
      <Button
        component={RouterLink}
        to="/app/similar-item-suggestions"
        variant="outlined"
        size="small"
        className="shrink-0"
      >
        Review similar items
      </Button>
    </Alert>
  );
};

export default SimilarItemWorkbenchEntry;
